import { compose } from 'lodash/fp';
import { connect } from 'react-redux';

import { BreakpointRange } from '@mews-distributor/common';
import { StyledTransitionGroup } from '@optimus-web/helpers';

import { Viewport } from '../../enhancers/types';
import { withViewport } from '../../enhancers/withViewport';
import { ApplicationState } from '../../types';
import { isViewportSufficient } from '../../utils/isViewportSufficient';
import { RateCompareContainer } from './RateCompareContainer';
import { shouldRateCompareRender } from './selectors';

interface RateCompareProps {
    shouldRender: boolean;
    viewport: Viewport;
}

const MINIMUM_VIEWPORT_HEIGHT = 650;

const BaseRateCompare = ({ shouldRender, viewport }: RateCompareProps) => {
    const sufficientViewport = isViewportSufficient(viewport, BreakpointRange.TabletPortrait, MINIMUM_VIEWPORT_HEIGHT);
    return (
        <StyledTransitionGroup>{shouldRender && sufficientViewport && <RateCompareContainer />}</StyledTransitionGroup>
    );
};

export const RateCompare = compose(
    withViewport,
    connect((state: ApplicationState) => ({
        shouldRender: shouldRateCompareRender(state, undefined), // shouldRateCompareRender needs to be typed
    }))
)(BaseRateCompare);
